'use strict';

function checkTradeAccelerator(token) {
    //debugger
    const reCaptchaVersion = document.getElementById('reCaptchaVersion').value;
    var gRecaptchaResponse;
    if (reCaptchaVersion == "ReCaptchaV2") {
        gRecaptchaResponse = $('#g-recaptcha-response').val();
    }
    else if (reCaptchaVersion == "ReCaptchaV3") {
        gRecaptchaResponse = token;
    }
    let benefits1 = "";
    let benefits2 = "";
    let benefits3 = "";
    let benefits4 = "";
    let benefits5 = "";
    let benefits6 = "";
    let benefits7 = "";
    let benefits8 = "";
    let benefits9 = "";
    let benefits10 = "";
    // const recaptcha = grecaptcha.getResponse();
    const fname = document.getElementById('tac-fname').value;
    const lname = document.getElementById('tac-lname').value;
    const email = document.getElementById('tac-email').value;
    const mobile = document.getElementById('tac-mob').value;
    const phone = document.getElementById('tac-phone').value;
    const accountcode = document.getElementById('tac-code').value;
    const businessName = document.getElementById('tac-account').value;
    const state = document.getElementById('tac-state').value;
    const homebranch = document.getElementById('homebranch').value;
    const homeBranchEmail = document.getElementById('homeBranchEmail').value;
    let validscterm = document.querySelectorAll('input[name="terms"]:checked');
    let benefitscheck = document.querySelectorAll('input[name="benefits"]');
    if (document.getElementById('benefits1').checked === true) {
        benefits1 = "Yes";
    }
    else {
        benefits1 = "No";
    }
    if (document.getElementById('benefits2').checked === true) {
        benefits2 = "Yes";
    }
    else {
        benefits2 = "No";
    }
    if (document.getElementById('benefits3').checked === true) {
        benefits3 = "Yes";
    }
    else {
        benefits3 = "No";
    }
    if (document.getElementById('benefits4').checked === true) {
        benefits4 = "Yes";
    }
    else {
        benefits4 = "No";
    }
    if (document.getElementById('benefits5').checked === true) {
        benefits5 = "Yes";
    }
    else {
        benefits5 = "No";
    }
    if (document.getElementById('benefits6').checked === true) {
        benefits6 = "Yes";
    }
    else {
        benefits6 = "No";
    }
    if (document.getElementById('benefits7').checked === true) {
        benefits7 = "Yes";
    }
    else {
        benefits7 = "No";
    }

    if (document.getElementById('benefits8').checked === true) {
        benefits8 = "Yes";
    }
    else {
        benefits8 = "No";
    }
    if (document.getElementById('benefits9').checked === true) {
        benefits9 = "Yes";
    }
    else {
        benefits9 = "No";
    }
    if (document.getElementById('benefits10').checked === true) {
        benefits10 = "Yes";
    }
    else {
        benefits10 = "No";
    }

    let valid = true;

    document.getElementById('errorfirstname').style.display = "none";
    document.getElementById('errorfirstnameCharLength').style.display = "none";
    document.getElementById('errorfirstnameInvalidChar').style.display = "none";
    document.getElementById('errorlastname').style.display = "none";
    document.getElementById('errorlastnameCharLength').style.display = "none";
    document.getElementById('errorlastnameInvalidChar').style.display = "none";
    document.getElementById('errorEmail').style.display = "none";
    document.getElementById('errorEmailCharLength').style.display = "none";
    document.getElementById('errorEmailInvalidChar').style.display = "none";
    document.getElementById('errormobile').style.display = "none";
    document.getElementById('errorphone').style.display = "none";
    document.getElementById('errorcode').style.display = "none";
    document.getElementById('errorcodeCharLength').style.display = "none";
    document.getElementById('errorcodeInvalidChar').style.display = "none";
    document.getElementById('errorTacAccountCharLength').style.display = "none";
    document.getElementById('errorTacAccountInvalidChar').style.display = "none";
    document.getElementById('errorstate').style.display = "none";
    document.getElementById('errorstateCharLength').style.display = "none";
    document.getElementById('errorstateInvalidChar').style.display = "none";
    document.getElementById('errorhome').style.display = "none";
    document.getElementById('errorhomeCharLength').style.display = "none";
    document.getElementById('errorhomeInvalidChar').style.display = "none";
    document.getElementById('errorbenefits').style.display = "none";
    document.getElementById('errorprivacy').style.display = "none";
    document.getElementById('errorCaptcha').style.display = "none";

    document.getElementById('tac-fname').classList.remove("field-error");
    document.getElementById('tac-lname').classList.remove("field-error");
    document.getElementById('tac-email').classList.remove("field-error");
    document.getElementById('tac-mob').classList.remove("field-error");
    document.getElementById('tac-phone').classList.remove("field-error");
    document.getElementById('tac-code').classList.remove("field-error");
    document.getElementById('tac-account').classList.remove("field-error");
    document.getElementById('tac-state').classList.remove("field-error");
    document.getElementById('homebranch').classList.remove("field-error");

    const charLengthErrorMessage = document.getElementById('charLimitErrorMessage').value;

    if (fname === "") {
        document.getElementById('tac-fname').classList.add("field-error");
        document.getElementById('errorfirstname').style.display = "block";
        valid = false;
    }
    else if (fname.length > 50) {
        document.getElementById('tac-fname').classList.add("field-error");
        document.getElementById('errorfirstnameCharLength').style.display = "block";
        valid = false;
    }
    else if (!IsInputNameValid(fname)) {
        document.getElementById('tac-fname').classList.add("field-error");
        document.getElementById('errorfirstnameInvalidChar').style.display = "block";
        valid = false;
    }

    if (lname === "") {
        document.getElementById('tac-lname').classList.add("field-error");
        document.getElementById('errorlastname').style.display = "block";
        valid = false;
    }
    else if (lname.length > 50) {
        document.getElementById('tac-lname').classList.add("field-error");
        document.getElementById('errorlastnameCharLength').style.display = "block";
        valid = false;
    }
    else if (!IsInputNameValid(lname)) {
        document.getElementById('tac-lname').classList.add("field-error");
        document.getElementById('errorlastnameInvalidChar').style.display = "block";
        valid = false;
    }

    if (email === "") {
        document.getElementById('tac-email').classList.add("field-error");
        document.getElementById('errorEmail').style.display = "block";
        valid = false;
    }
    else if (email.length > 60) {
        document.getElementById('tac-email').classList.add("field-error");
        document.getElementById('errorEmailCharLength').style.display = "block";
        valid = false;
    }
    else if (!ValidateEmailRegex(email)) {
        document.getElementById('tac-email').classList.add("field-error");
        document.getElementById('errorEmail').style.display = "block";
        valid = false;
    }
    else if (!IsInputSecure(email, true)) {
        document.getElementById('tac-email').classList.add("field-error");
        document.getElementById('errorEmailInvalidChar').style.display = "block";
        valid = false;
    }

    if ((mobile === "") && (phone === "")) {
        document.getElementById('tac-mob').classList.add("field-error");
        document.getElementById('tac-phone').classList.add("field-error");
        document.getElementById('errormobile').style.display = "block";
        valid = false;
    }
    if ((mobile !== "") || (phone !== "")) {
        if (mobile != "") {
            if (mobile.length > 15) {
                document.getElementById('tac-mob').classList.add("field-error");
                document.getElementById('errormobile').style.display = "block";
                document.getElementById('errormobile').innerHTML = charLengthErrorMessage;
                valid = false;
            }
            else if (!IsMobileValid(mobile)) {
                document.getElementById('tac-mob').classList.add("field-error");
                document.getElementById('errormobile').style.display = "block";
                document.getElementById('errormobile').innerHTML = "Mobile number is required";
                valid = false;
            }
        }

        if (phone != "") {
            if (phone.length > 15) {
                document.getElementById('tac-phone').classList.add("field-error");
                document.getElementById('errorphone').style.display = "block";
                document.getElementById('errorphone').innerHTML = charLengthErrorMessage;
                valid = false;
            }
            else if (!ValidatePhoneRegex(phone)) {
                document.getElementById('tac-phone').classList.add("field-error");
                document.getElementById('errorphone').style.display = "block";
                document.getElementById('errorphone').innerHTML = "Contact number is required";
                valid = false;
            }
        }
    }

    if (accountcode === "") {
        document.getElementById('tac-code').classList.add("field-error");
        document.getElementById('errorcode').style.display = "block";
        valid = false;
    }
    else if (accountcode.length < 3) {
        document.getElementById('tac-code').classList.add("field-error");
        document.getElementById('errorcode').style.display = "block";
        valid = false;
    }
    else if (accountcode.length > 10) {
        document.getElementById('tac-code').classList.add("field-error");
        document.getElementById('errorcodeCharLength').style.display = "block";
        valid = false;
    }
    else if (!IsInputSecure(accountcode)) {
        document.getElementById('tac-code').classList.add("field-error");
        document.getElementById('errorcodeInvalidChar').style.display = "block";
        valid = false;
    }

    if (businessName !== "") {
        if (businessName.length > 50) {
            document.getElementById('tac-account').classList.add("field-error");
            document.getElementById('errorTacAccountCharLength').style.display = "block";
            valid = false;
        }
        else if (!IsInputSecure(businessName)) {
            document.getElementById('tac-account').classList.add("field-error");
            document.getElementById('errorTacAccountInvalidChar').style.display = "block";
            valid = false;
        }
    }

    if (state === "Please Select") {
        document.getElementById('tac-state').classList.add("field-error");
        document.getElementById('errorstate').style.display = "block";
        valid = false;
    }
    else if (!IsInputSecure(state)) {
        document.getElementById('tac-state').classList.add("field-error");
        document.getElementById('errorstateInvalidChar').style.display = "block";
        valid = false;
    }

    if (homebranch === "") {
        document.getElementById('homebranch').classList.add("field-error");
        document.getElementById('errorhome').style.display = "block";
        valid = false;
    }
    else if (homebranch.length > 100) {
        document.getElementById('homebranch').classList.add("field-error");
        document.getElementById('errorhomeCharLength').style.display = "block";
        valid = false;
    }
    else if (!IsInputSecure_MiddysBranchSearch(homebranch)) {
        document.getElementById('homebranch').classList.add("field-error");
        document.getElementById('errorhomeInvalidChar').style.display = "block";
        valid = false;
    }
    else if (homeBranchEmail === "") {
        document.getElementById('homebranch').classList.add("field-error");
        document.getElementById('errorhome').style.display = "block";
        valid = false;
    }

    let check = "";
    for (let i = 0; i < benefitscheck.length; i++) {
        let inputID = "benefits" + (i + 1);
        if (document.getElementById(inputID).checked === true) {
            check = "true";
            break;
        }
    }

    if (check === "") {
        document.getElementById('tac-benefits').classList.add("field-error");
        document.getElementById('errorbenefits').style.display = "block";
        valid = false;
    }

    if (validscterm.length === 0) {
        document.getElementById('terms').classList.add("field-error");
        document.getElementById('errorprivacy').style.display = "block";
        valid = false;
    }

    if (reCaptchaVersion == "ReCaptchaV2") {
        const recaptcha = grecaptcha.getResponse();
        if (recaptcha === "") {
            document.getElementById('errorCaptcha').style.display = "block";
            valid = false;
        }
    }

    if (valid === true) {
        document.getElementById('errorCaptcha').style.display = "none";
        document.getElementById('SubmissionErrorMessage').innerHTML = "";
        document.getElementById('SubmissionErrorMessage').style.display = "none";

        let formData = new FormData();
        formData.append('Firstname', fname);
        formData.append('Lastname', lname);
        formData.append('Email', email);
        formData.append('Mobile', mobile);
        formData.append('Phone', phone);
        formData.append('AccountCode', accountcode);
        formData.append('AccountName', businessName);
        formData.append('State', state);
        formData.append('HomeBranch', homebranch);
        formData.append('HomeBranchEmail', homeBranchEmail);
        formData.append('DiscountedMiddysAcademyTraining', benefits1);
        formData.append('BonusPromotionEntries', benefits2);
        formData.append('ApprenticeProgram', benefits3);
        formData.append('ExpressPriorityDelivery', benefits4);
        formData.append('FreeSMARTSpecProposals', benefits5);
        formData.append('SmartIntegrationServices', benefits6);
        formData.append('DiscountswithAffiliatePartnerOffers', benefits7);
        formData.append('FreeEnergyTrustProposals', benefits8);
        formData.append('CustomerLeadsViaTheMiddysHomeServices', benefits9);

        if (reCaptchaVersion == "ReCaptchaV2") {
            SubmitForm_TradeAccelerator(formData, gRecaptchaResponse);
        }
        else if (reCaptchaVersion == "ReCaptchaV3") {
            var siteKey = document.getElementById('reCaptchaV3SiteKey').value;
            grecaptcha.ready(function () {
                grecaptcha.execute(siteKey, { action: 'trade_accelerator' }).then(function (gRecaptchaResponse) {
                    SubmitForm_TradeAccelerator(formData, gRecaptchaResponse);
                });
            });
        }
    }
    else {
        getTabHeight();
    }

}

function SubmitForm_TradeAccelerator(formData, gRecaptchaResponse) {
    formData.append('GRecaptchaResponse', gRecaptchaResponse);

    const url = "/TradeAccelerator/SaveTradeAcceleratorForm";

    fetch(url,
    {
        body: formData,
        method: "post",
        headers: {
            "RequestVerificationToken": $("#formtrade [name='__RequestVerificationToken']").val()
        }
    }).then(response => {
        if (!response.ok) {
            document.getElementById('SubmissionErrorMessage').innerHTML = $("#formSubmissionErrorMessage").val();
            document.getElementById('SubmissionErrorMessage').style.display = "block";
        }
        return response.text()
    })
    .then(data => {
        //make sure response does not contain any unhandled error
        if (!data.includes("<html>")) {
            if (data == "Submit") {
                document.getElementById('form2').classList.add("active");
                document.getElementById('form1').classList.remove("active");
                document.getElementById('tradeFormHeading').style.display = "none";

                $("#formtrade")[0].reset()
                grecaptcha.reset();
                getTabHeight();
                var st = $('.tabs-wrap').offset().top;
                if (!isMobile()) {
                    $('html').animate({
                        scrollTop: st - 220
                    })
                }
                else {
                    $('html').animate({
                        scrollTop: st - 120
                    })
                }
            }
            else if (data.startsWith("1")) {
                document.getElementById('SubmissionErrorMessage').innerHTML = data.slice(1);
                document.getElementById('SubmissionErrorMessage').style.display = "block";
            }
            else {
                document.getElementById('errorCaptcha').style.display = "block";
                document.getElementById('errorCaptcha').innerHTML = data;
            }
        }
    });
}

function isMobile(){
  return $(window).width() < 768;
}

function getTabHeight() {
    var tabActive = $('.tabs-wrap .tab.active').outerHeight();
    $('.tabs-wrap').css('height', tabActive);
}

$("#homebranch").keyup(function (e) {
    var txt = $(this).val().trim();

    if (txt != "") {
        const url = "/api/branchlocator/SearchBranchByName?search=" + txt;

        fetch(url, {
            headers: {
                'Content-Type': 'application/json',
                "RequestVerificationToken": $("#checkloginApi [name='__RequestVerificationToken']").val()
            },
        })
        .then(response => response.text())
        .then(data => bindhomebranch(data));
    }
    else {
        document.getElementById("autocomplete-wrap").style.display = "none";
    }
});

function bindhomebranch(data) {
    let jsobject = JSON.parse(data);
    let divElement = document.getElementById("autocomplete-wrap");
    divElement.style.display = "block";
    divElement.innerHTML = "";
    if (jsobject.length === 0) {
        let aelem = document.createElement("a");
        aelem.className = "autocomplete-items";
        aelem.innerHTML = "No Result Found";
        divElement.appendChild(aelem);
    } else {
        for (let i = 0; i <= jsobject.length - 1; i++) {
            let aelem = document.createElement("a");
            aelem.className = "autocomplete-items";
            aelem.innerHTML = jsobject[i].name;
            aelem.dataset.email = jsobject[i].email;
            aelem.id = i;
            aelem.setAttribute('onclick', "inputhomebranch(event)");
            divElement.appendChild(aelem);
        }
    }

    document.getElementById("id1").appendChild(divElement);
}

function inputhomebranch(event) {
    const value = event.currentTarget.innerHTML;
    const branchEmail = event.currentTarget.dataset.email;
    document.getElementById('homebranch').value = value;
    document.getElementById('homeBranchEmail').value = branchEmail;
    document.getElementById("autocomplete-wrap").style.display = "none";
}

document.querySelectorAll('#tac-benefits>label').forEach(item => {
    item.addEventListener('click', event => {
        //debugger;
        const dropdowmID = document.querySelectorAll('#tac-benefits>label');

        if (event.target.innerHTML === "Select all") {
            for (let i = 0; i < dropdowmID.length; i++) {
                let inputID = "benefits" + (i + 1);
                document.getElementById(inputID).checked = true;
            }
        }
    });
});

var selectAllCheck = false;
function Selectallbenefits() {
    const dropdowmID = document.querySelectorAll('#tac-benefits>input');
    for (let i = 0; i < dropdowmID.length; i++) {
        let inputID = "benefits" + (i + 1);
        if (selectAllCheck) {
            document.getElementById(inputID).checked = false;
        } else {
            document.getElementById(inputID).checked = true;
        }
        if (selectAllCheck === false && i == dropdowmID.length-1) {
            selectAllCheck = true;
            document.getElementById("selectAllInnerHTML").innerHTML = "Unselect all";
        }else if (selectAllCheck === true && i == dropdowmID.length - 1) {
            selectAllCheck = false;
            document.getElementById("selectAllInnerHTML").innerHTML = "Select all";
        }
    }
}